import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'spaceString'
})
export class SpaceStringPipe implements PipeTransform {
  transform(value: string, every: number): string {
    if (!value || !every || every <= 0) return value;
    const regex = new RegExp(`(.{${every}})`, 'g');
    return value.replace(/\s/g, '').replace(regex, '$1  ').trim();
  }
}
